import { Checkbox } from '@radix-ui/themes';
import { Table } from '@tanstack/react-table';

interface TableSelectionHeaderProps<TData extends { id: string }> {
    table: Table<TData>;
}

export const TableSelectionHeader = <TData extends { id: string }>({
    table,
}: TableSelectionHeaderProps<TData>) => {
    const isAllSelected = table.getIsAllPageRowsSelected();
    const isSomeSelected = table.getIsSomePageRowsSelected();
    const checkState = isSomeSelected ? 'indeterminate' : isAllSelected;
    const canSelectAll = table
        .getRowModel()
        .rows.some((row) => row.getCanSelect());

    return (
        <Checkbox
            // highContrast
            color='gray'
            checked={checkState}
            mx={'1'}
            onCheckedChange={(value) =>
                table.toggleAllPageRowsSelected(!isSomeSelected && !!value)
            }
            aria-label={'Select all rows'}
            disabled={!canSelectAll}
        />
    );
};
